import React, { useState } from 'react';
import { X, Bell, Loader2, Check } from 'lucide-react';

const BuildNotifyModal = ({ step, buildId, clientEmail, password, onClose, onSent }) => {
  const [note, setNote] = useState('');
  const [email, setEmail] = useState(clientEmail || '');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const send = async () => {
    if (!step || !buildId) return;
    setLoading(true);
    try {
      const res = await fetch('/api/notify-client', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'x-admin-password': password },
        body: JSON.stringify({
          build_package_id: buildId,
          step_id: step.id,
          note: note || null,
          client_email: email || null,
        }),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.error || 'Failed to notify');
      setSent(true);
      setTimeout(() => { onSent?.(); onClose(); }, 1200);
    } catch (err) {
      alert(`Notify error: ${err.message}`);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm">
      <div className="bg-[#18181B] border border-[#F0EFF4]/10 rounded-2xl w-full max-w-md shadow-2xl">
        {/* Header */}
        <div className="flex items-center justify-between px-5 py-4 border-b border-[#F0EFF4]/10">
          <div className="flex items-center gap-2">
            <Bell className="w-4 h-4 text-blue-400" />
            <span className="font-bold text-[#F0EFF4] text-sm">Notify Client</span>
          </div>
          <button onClick={onClose} className="p-1 rounded-lg hover:bg-[#F0EFF4]/10 text-[#F0EFF4]/60 transition-colors">
            <X className="w-4 h-4" />
          </button>
        </div>

        {/* Body */}
        <div className="px-5 py-4 space-y-4">
          <div>
            <div className="text-xs text-[#F0EFF4]/40 mb-1 font-data">Step</div>
            <div className="text-sm text-[#F0EFF4] font-bold">{step?.label}</div>
            <div className="text-xs text-[#F0EFF4]/30 font-data">{step?.id}</div>
          </div>

          <div>
            <label className="text-xs text-[#F0EFF4]/40 font-data block mb-1">Client Email</label>
            <input
              value={email}
              onChange={e => setEmail(e.target.value)}
              placeholder="client@email.com"
              className="w-full bg-[#F0EFF4]/5 border border-[#F0EFF4]/10 rounded-lg px-3 py-2 text-sm text-[#F0EFF4] placeholder-[#F0EFF4]/20 outline-none focus:border-[#7B61FF]/50"
            />
          </div>

          <div>
            <label className="text-xs text-[#F0EFF4]/40 font-data block mb-1">Note (optional)</label>
            <textarea
              value={note}
              onChange={e => setNote(e.target.value)}
              rows={3}
              placeholder="Add context for the client…"
              className="w-full bg-[#F0EFF4]/5 border border-[#F0EFF4]/10 rounded-lg px-3 py-2 text-sm text-[#F0EFF4] placeholder-[#F0EFF4]/20 outline-none focus:border-[#7B61FF]/50 resize-none"
            />
          </div>
        </div>

        {/* Footer */}
        <div className="flex items-center justify-end gap-2 px-5 py-4 border-t border-[#F0EFF4]/10">
          <button
            onClick={onClose}
            className="px-4 py-2 text-sm text-[#F0EFF4]/60 hover:text-[#F0EFF4] bg-[#F0EFF4]/5 hover:bg-[#F0EFF4]/10 rounded-lg transition-colors"
          >
            Cancel
          </button>
          <button
            onClick={send}
            disabled={loading || sent}
            className="flex items-center gap-2 px-4 py-2 text-sm font-bold bg-blue-500 hover:bg-blue-600 disabled:opacity-50 text-white rounded-lg transition-colors"
          >
            {sent
              ? <><Check className="w-4 h-4" /> Sent!</>
              : loading
              ? <><Loader2 className="w-4 h-4 animate-spin" /> Sending…</>
              : <><Bell className="w-4 h-4" /> Send Notification</>
            }
          </button>
        </div>
      </div>
    </div>
  );
};

export default BuildNotifyModal;
